import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DsLayout } from "shared/constants";
import {IDsLayoutState} from "dataModels/stateModels/dslayout";

const dsLayoutInitialState:IDsLayoutState = {
    mode:DsLayout.LIGHT_MODE
}
export const dsModeSlice = createSlice({
    name:"dsLayout",
    initialState:dsLayoutInitialState,
    reducers:{
        toggleLayoutMode:(state:IDsLayoutState)=>{
            state.mode=DsLayout.LIGHT_MODE?DsLayout.DARK_MODE:DsLayout.LIGHT_MODE;
        },
        setLayoutMode(state:IDsLayoutState, action:PayloadAction<DsLayout>){
            state.mode = action.payload;
        }
    }
});
export const {toggleLayoutMode, setLayoutMode} = dsModeSlice.actions;
export default dsModeSlice.reducer;